import { createContext } from 'react';
import { ModalSize, modalDefaultProps } from '@gs-ux-uitoolkit-common/modal';

export const ModalSizeContext = createContext<ModalSize>(modalDefaultProps.size);
